<form [formGroup]="form" [attr.autocomplete]="'off'">
  <div class="form-row">
    <mat-form-field [appearance]="appearance">
      @if (showLabel) {
        <mat-label>{{ modelLabel }}</mat-label>
      }

      <mat-chip-grid #chipList aria-label="Model selection" [disabled]="unknownModel.value">
        @for (model of selectedModel; track model) {
          <mat-chip-row [removable]="removable" (removed)="removeModel()">
            {{ model }}
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }

        <input
          matInput
          #modelInput
          [formControl]="modelCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addModel($event)"
          matChipInputAddOnBlur="true"
          />
        </mat-chip-grid>

        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (model of filteredModeller | async; track model) {
            <mat-option [disabled]="model.modelstatus === 'No'" [value]="model.name">
              {{ model.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-slide-toggle formControlName="unknownModel" (change)="unknownSlideChanged($event)">Model kendes ikke</mat-slide-toggle>
    </div>
  </form>
